import React from 'react'
import '../scss/all.scss'
import { FormattedMessage } from 'gatsby-plugin-intl';
import { get_title } from '../misc/category_master';
import { Link } from './Link';
import Helmet from "react-helmet";
import { create_breadcrumb } from "../misc/json_ld";

export default ({ paths = [], title = null, slug = null, language = 'ja' }) => {
  const elements = [
    {
      position: 1,
      name: 'ヘルプ',
      item: `https://help.social-dog.net/${language}/`,
    },
    ...paths.map((i, index) => {
      return {
        name: get_title(paths.slice(0, index + 1)),
        position: index + 2,
        item: `/${language}/help/${paths.slice(0, index + 1).join('/')}/`,
      };
    }),
  ];
  if (title && slug) {
    elements.push({
      name: title,
      position: elements.length + 1,
      item: `/${language}/help${slug}`
    })
  }

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(create_breadcrumb(elements))}
        </script>
      </Helmet>
      <div className="container">
        <ol
          itemScope=""
          itemType="https://schema.org/BreadcrumbList"
          className="breadcrumb"
        >
          <li
            itemProp="itemListElement"
            itemScope=""
            itemType="https://schema.org/ListItem"
          >
            <a
              itemType="https://schema.org/Thing"
              itemProp="item"
              href={`https://help.social-dog.net/${language}/`}
            >
              <span itemProp="name">
                <FormattedMessage id="ヘルプ" />
              </span>
            </a>
            <meta itemProp="position" content="1" />
          </li>
          {paths.map((i, index) => (
            <li
              itemProp="itemListElement"
              itemScope=""
              itemType="https://schema.org/ListItem"
              key={i}
            >
              <Link to={`/${paths.slice(0, index + 1).join('/')}/`}>
                <span itemProp="name">
                  <FormattedMessage id={get_title(paths.slice(0, index + 1))} />
                </span>
              </Link>
              <meta itemProp="position" content="2" />
            </li>
          ))}
          {title && slug && (
            <li
              itemProp="itemListElement"
              itemScope=""
              itemType="https://schema.org/ListItem"
            >
              <Link to={`${slug}`}>
                <span itemProp="name">{title}</span>
              </Link>
              <meta itemProp="position" content="4" />
            </li>
          )}
        </ol>
      </div>
    </>
  );
};
